import store from '@/store'
export default [
  {
    path: '/exchange-rates',
    name: 'exchange-rate',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exchange-rate/index-v2.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('exchangeRate/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/exchange-rates/:id',
    name: 'exchange-rate-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exchange-rate/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('exchangeRate/dataBeforeCreate')
      let response = await store.dispatch('exchangeRate/find', to.params.id)
      let { currencies, ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
